export default "__VITE_ASSET__CuwUshtA__"